import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Grid, Card, CardContent, Button, List, ListItem, ListItemIcon, ListItemText, Chip, Stack, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StarIcon from '@mui/icons-material/Star';
import CallToAction from '../widgets/CallToAction';

export default function AbonnementsEcoles() {
    // Offre unique
    const offer = {
        name: 'Offre École',
        setupTime: 'Mise en place en 14 jours',
        description: "Une formule unique, complète et simple à déployer pour piloter votre carrière center et l'insertion.",
        included: [
            'Carrière center',
            'Messagerie',
            'Jobboard et CVthèque',
            'Matching',
            'Entretiens IA',
            'Entreprises partenaires',
            'Suivi des candidatures'
        ],
        options: [
            'Connexions API',
            'Marque Blanche',
            'Signature de Conventions'
        ]
    };

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
            <Helmet>
                <title>Écoles — Abonnements & options | Student Link</title>
                <meta name="description" content="Offre unique pour career center: carrière center, messagerie, jobboard, matching IA, entretiens IA et plus." />
                <link rel="canonical" href="https://studentlink.fr/ecoles/abonnements" />
            </Helmet>
            {/* HERO */}
            <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
                <Typography variant="h2" component="h1" sx={{ fontWeight: 700 }}>
                    Un format unique, facile et complet
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mt: 1, maxWidth: 820, mx: 'auto', fontWeight: 400 }}>
                    Une offre simple qui regroupe vos besoins clés, avec un déploiement rapide et un accompagnement dédié.
                </Typography>
            </Box>

            {/* PRICING CARD */}
            <Grid container spacing={4} justifyContent="center" sx={{ mb: { xs: 6, md: 10 } }}>
                <Grid item xs={12} md={9} lg={8}>
                    <Card sx={{ p: { xs: 2.5, md: 3 }, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                        <CardContent sx={{ p: { xs: 1, md: 2 } }}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" spacing={1} sx={{ mb: 2 }}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography variant="h4" sx={{ fontWeight: 700 }}>
                                        {offer.name}
                                    </Typography>
                                    <Chip label={offer.setupTime} color="primary" size="small" />
                                </Stack>

                            </Stack>

                            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                                {offer.description}
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={7}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Inclus par défaut</Typography>
                                    <List sx={{ mb: 1 }}>
                                        {offer.included.map((feature, idx) => (
                                            <ListItem key={`inc-${idx}`} sx={{ px: 0, py: 0.5 }}>
                                                <ListItemIcon sx={{ minWidth: 30 }}>
                                                    <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />
                                                </ListItemIcon>
                                                <ListItemText primary={feature} primaryTypographyProps={{ fontSize: 14 }} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Options à la carte</Typography>
                                    <List>
                                        {offer.options.map((opt, idx) => (
                                            <ListItem key={`opt-${idx}`} sx={{ px: 0, py: 0.5 }}>
                                                <ListItemIcon sx={{ minWidth: 30 }}>
                                                    <StarIcon sx={{ color: '#FFB020', fontSize: 20 }} />
                                                </ListItemIcon>
                                                <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 14 }} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* FINAL CTA */}
            <CallToAction
                title="Besoin d'un devis sur-mesure ?"
                subtitle="Parlez-nous de votre établissement et de vos objectifs. Nous reviendrons vers vous très rapidement."
                actions={(
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                        <Button component="a" href="https://calendly.com/j-derosnay-studentlink/30min" target="_blank" rel="noopener noreferrer" variant="outlined" sx={{ height: 48, borderRadius: 4, px: 2.5 }}>Réserver une démo</Button>
                        <Button href="/contact" variant="contained" sx={{ height: 48, borderRadius: 4, px: 2.5 }}>Nous contacter</Button>
                    </Stack>
                )}
                sx={{ mt: { xs: 6, md: 8 } }}
            />
        </Container>
    );
}